import React from 'react'
import {
  BrowserRouter as Router,
  Switch
} from 'react-router-dom'

import { PublicRoute, PrivateRoute } from '../components'
import { Login, Home, Appointments, Messages, Posts, Offers, Users, Terms } from '../scenes'

export default function Navigation() {
  return (
    <Router>
      <div className="app">
        <Switch>
          <PublicRoute path="/login">
            <Login />
          </PublicRoute>
          <PublicRoute path="/policy">
            <Terms />
          </PublicRoute>
          <PrivateRoute path="/posts">
            <Posts />
          </PrivateRoute>
          <PrivateRoute path="/promociones">
            <Offers />
          </PrivateRoute>
          <PrivateRoute path="/citas">
            <Appointments />
          </PrivateRoute>
          <PrivateRoute path="/mensajes">
            <Messages />
          </PrivateRoute>
          <PrivateRoute path="/users">
            <Users />
          </PrivateRoute>
          <PrivateRoute path="/">
            <Home />
          </PrivateRoute>
        </Switch>
      </div>
    </Router>
  )
}